import { apiClient } from './apiClient';

const BASE = '/api/app/settings';

export enum SettingType {
  Text = 0,
  Number = 1,
  Boolean = 2,
  Email = 3,
  Url = 4,
  TextArea = 5,
}

export interface SettingItemDto {
  name: string;
  displayName: string;
  description: string;
  value: string;
  type: SettingType;
  defaultValue: string;
}

export interface SettingGroupDto {
  groupName: string;
  displayName: string;
  settings: SettingItemDto[];
}

export interface SettingValueDto {
  name: string;
  value: string;
}

export interface UpdateSettingsDto {
  settings: SettingValueDto[];
}

export const settingsService = {
  getAll: async (): Promise<SettingGroupDto[]> => {
    const { data } = await apiClient.get<SettingGroupDto[]>(`${BASE}/all`);
    return data;
  },

  update: async (input: UpdateSettingsDto): Promise<void> => {
    await apiClient.put(BASE, input);
  },

  getByNames: async (names: string[]): Promise<SettingItemDto[]> => {
    const { data } = await apiClient.post<SettingItemDto[]>(`${BASE}/by-names`, names);
    return data;
  },
};
